export enum VIEW_MODE {
    COLLAPSED = 'collapsed',
    FULL = 'full'
}
